const privacyPolicyContent = {
  "en-US": {
    privacypolicy: "Privacy Policy",

    "privacy-policy": "Privacy Policy",
    lastupdated: "Last Updated",
    privacyPolicyDoc: {
      title: "Terms of Service & Privacy Policy",
      lastUpdatedDate: "July 21, 2026",
      parts: [
        {
          title: "Part I — Terms of Service",
          intro: [
            "The Services are provided by Fire Rover, LLC. (\"Fire Rover,\" \"we,\" \"us,\" or \"our\"), located in Farmington Hills, Michigan, United States.",
            "By creating an account, accessing, or using the Services, you agree to be bound by these Terms of Service and acknowledge that you have read and understood this Privacy Policy. If you do not agree, do not use the Services.",
          ],
          sections: [
            {
              title: "1. The Services",
              body: [
                "The Services provide tools for monitoring and managing Fire Rover fire suppression systems, including receiving real-time alerts and notifications about fire suppression events; viewing event notification history; viewing incident reports, operation focus reports, and system video; viewing system-health status of associated equipment; managing sites, systems/units, and associated users; inviting users and assigning or removing site-manager roles; and configuring personal information and notification preferences (email, SMS/text, and push), schedules, language, and time zone. The Services are a supplementary notification and management tool. They are NOT a substitute for a properly installed and maintained fire suppression system, a monitored central station, local fire and life-safety systems, or emergency services.",
              ],
            },
            {
              title: "2. Eligibility and Accounts",
              body: [
                "The Services are intended for business use by customers, partners, and authorized personnel of Fire Rover. Account creation requires a valid registration code issued by Fire Rover or an authorized party. You must provide accurate information, be authorized to act on behalf of any site or organization you are associated with, keep your password confidential, and remain responsible for all activity under your account. Notify us promptly at app-dev@firerover.com of any unauthorized use.",
              ],
            },
            {
              title: "3. Acceptable Use",
              body: [
                "You agree not to: use the Services for any unlawful purpose; access or tamper with non-public areas; probe or test security measures; interfere with or disrupt the Services; reverse engineer the Services except as permitted by law; access data for sites or users you are not authorized to access; or misrepresent your identity or affiliation.",
              ],
            },
            {
              title: "4. User Roles and Site Management",
              body: [
                "Certain users may be designated as site managers with elevated permissions. If you exercise these permissions, you represent that you are authorized to do so and that doing so complies with your organization's policies and applicable law.",
              ],
            },
            {
              title: "5. Notifications and Communications",
              body: [
                "By configuring notification preferences, you consent to receive operational communications through the channels you enable (email, SMS/text, and/or push). Message and data rates may apply. You may change or disable notification channels at any time within the Services.",
              ],
            },
            {
              title: "6. Intellectual Property",
              body: [
                "The Services, including all software, content, designs, logos, and trademarks (including \"Fire Rover\" and \"Spark Mobile\"), are owned by Fire Rover, LLC. or its licensors. We grant you a limited, non-exclusive, non-transferable, revocable license to use the Services solely for their intended purpose.",
              ],
            },
            {
              title: "7. Your Data",
              body: [
                "You retain ownership of the personal and account information you provide. By using the Services, you grant Fire Rover the right to process such information as described in the Privacy Policy to provide and improve the Services.",
              ],
            },
            {
              title: "8. Third-Party Services",
              body: [
                "The Services rely on third-party providers including cloud hosting and push notification delivery. We are not responsible for the acts, omissions, or content of third parties.",
              ],
            },
            {
              title: "9. Disclaimers",
              body: [
                "THE SERVICES ARE PROVIDED \"AS IS\" AND \"AS AVAILABLE,\" WITHOUT WARRANTIES OF ANY KIND. Notification delivery is not guaranteed. Delivery of alerts depends on factors outside our control, including carrier networks, internet connectivity, device settings, operating-system limits, and third-party infrastructure. Do not rely on the Services as your sole means of receiving emergency notice.",
              ],
            },
            {
              title: "10. Limitation of Liability",
              body: [
                "TO THE MAXIMUM EXTENT PERMITTED BY LAW, FIRE ROVER, LLC. AND ITS OFFICERS, DIRECTORS, EMPLOYEES, AND AGENTS WILL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS, REVENUE, DATA, OR GOODWILL. OUR TOTAL AGGREGATE LIABILITY WILL NOT EXCEED ONE HUNDRED U.S. DOLLARS (US$100).",
              ],
            },
            {
              title: "11. Indemnification",
              body: [
                "You agree to indemnify and hold harmless Fire Rover, LLC. and its affiliates from any claims, damages, liabilities, and expenses arising out of your violation of these Terms, your misuse of the Services, or your violation of any law or third-party rights.",
              ],
            },
            {
              title: "12. Suspension and Termination",
              body: [
                "We may suspend or terminate your access at any time, with or without notice, if we believe you have violated these Terms. You may stop using the Services at any time.",
              ],
            },
            {
              title: "13. Governing Law and Disputes",
              body: [
                "These Terms are governed by the laws of the State of Michigan, United States. Any dispute will be subject to the exclusive jurisdiction of the state and federal courts located in Michigan.",
              ],
            },
            {
              title: "14. Changes to These Terms",
              body: [
                "We may update these Terms from time to time. Continued use after changes become effective constitutes acceptance of the revised Terms.",
              ],
            },
            {
              title: "15. Contact",
              body: ["legalnotice@firerover.com"],
            },
          ],
        },
        {
          title: "Part II — Privacy Policy",
          intro: [],
          sections: [
            {
              title: "1. Information We Collect",
              body: [
                "a. Information You Provide: Account and profile information (first and last name, email address, phone number with country code, password stored only in hashed form, time zone, and preferred language); registration code; notification preferences (alert types, delivery methods, schedules, and notification modes); site and user management actions.",
                "b. Information Collected Automatically: Authentication tokens (JWT access and refresh tokens stored in secure device storage on mobile and browser cookies on web); push notification tokens via Expo/APNs/FCM; device and diagnostic information for crash reporting (platform, OS version, error messages, stack traces, error type, fatal flag, timestamp); web storage (local storage for \"Remember me\" email and theme preference; cookies for name, username, role flags, and auth tokens).",
                "c. Information About Sites and Events: Site names and addresses, central-station information, equipment details, and event notification history (event type, site and product name, timestamps, test-alert flags, and related images where available).",
              ],
            },
            {
              title: "2. How We Use Information",
              body: [
                "To authenticate you and maintain your session; provide core Services functions including delivering alerts; display sites, systems, event history, and system-health information; enable site and user management; send account communications (password-reset codes and invitations); diagnose, debug, and improve the Services; and maintain security and comply with legal obligations.",
              ],
            },
            {
              title: "3. Legal Bases for Processing",
              body: [
                "Where required by applicable law (such as the EU/UK GDPR), we process personal information based on: performance of a contract, your consent (for example, enabling SMS or push notifications), our legitimate interests (securing and improving the Services), and compliance with legal obligations.",
              ],
            },
            {
              title: "4. How We Share Information",
              body: [
                "We do NOT sell your personal information. We share only with: service providers that host and operate the Services (Microsoft Azure for cloud hosting; Apple Push Notification service and Google Firebase Cloud Messaging via Expo for push delivery; telecommunications/email providers for SMS and email); within your organization where authorized; for legal and safety reasons when required by law; and in connection with a business transfer.",
              ],
            },
            {
              title: "5. Data Storage and Security",
              body: [
                "We use encrypted transport (HTTPS) for all backend communication, token-based authentication (JWT) with automatic refresh and limited session lifetimes, secure on-device credential storage in the mobile app, and passwords stored only in hashed form. Data is processed and stored on Microsoft Azure infrastructure and may be processed in the United States and other countries where our service providers operate.",
              ],
            },
            {
              title: "6. Data Retention",
              body: [
                "We retain personal information for as long as your account is active and as needed to provide the Services, comply with legal obligations, resolve disputes, and enforce our agreements. To request deletion, contact app-dev@firerover.com.",
              ],
            },
            {
              title: "7. Children's Privacy",
              body: [
                "The Services are intended for business use by adults and are not directed to children under 13. We do not knowingly collect personal information from children.",
              ],
            },
            {
              title: "8. Your Choices and Rights",
              body: [
                "You can view and update your profile, contact information, and notification preferences within the Services. Depending on where you live, you may have rights under laws such as the GDPR or CCPA, including the right to access, correct, delete, or port your personal information, and to object to or restrict certain processing. To exercise these rights, contact app-dev@firerover.com.",
              ],
            },
            {
              title: "9. Third-Party Services and Links",
              body: [
                "The Services depend on third-party platforms (Microsoft Azure, Apple, Google, and Expo) whose privacy practices are governed by their own policies.",
              ],
            },
            {
              title: "10. Changes to This Privacy Policy",
              body: [
                "We may update this Privacy Policy from time to time. Continued use after an update constitutes acceptance of the revised Privacy Policy.",
              ],
            },
            {
              title: "11. Contact Us",
              body: [
                "Fire Rover, LLC., Farmington Hills, Michigan, United States | app-dev@firerover.com | https://firerover.com",
              ],
            },
          ],
        },
      ],
    },
  },

  "fr-FR": {
    privacypolicy: "Politique de confidentialité",
    "privacy-policy": "Politique de confidentialité",
    lastupdated: "Dernière mise à jour",
    privacyPolicyDoc: {
      title: "Conditions d'utilisation et politique de confidentialité",
      lastUpdatedDate: "21 juillet 2026",
      parts: [
        {
          title: "Partie I — Conditions d'utilisation",
          intro: [
            "Les Services sont fournis par Fire Rover, LLC. (« Fire Rover », « nous » ou « notre »), situé à Farmington Hills, Michigan, États-Unis.",
            "En créant un compte, en accédant aux Services ou en les utilisant, vous acceptez d'être lié par les présentes Conditions d'utilisation et reconnaissez avoir lu et compris la présente politique de confidentialité. Si vous n'êtes pas d'accord, n'utilisez pas les Services.",
          ],
          sections: [
            {
              title: "1. Les Services",
              body: [
                "Les Services fournissent des outils pour surveiller et gérer les systèmes d'extinction d'incendie Fire Rover, notamment : recevoir des alertes et des notifications en temps réel concernant les événements d'extinction d'incendie ; consulter l'historique des notifications d'événements ; consulter les rapports d'incident, les rapports de suivi des opérations et la vidéo du système ; consulter l'état de santé des équipements associés ; gérer les sites, les systèmes/unités et les utilisateurs associés ; inviter des utilisateurs et attribuer ou retirer des rôles de gestionnaire de site ; et configurer les informations personnelles et les préférences de notification (e-mail, SMS/texto et notifications push), les horaires, la langue et le fuseau horaire. Les Services constituent un outil complémentaire de notification et de gestion. Ils ne remplacent PAS un système d'extinction d'incendie correctement installé et entretenu, une station centrale de surveillance, les systèmes locaux de sécurité incendie et de sauvegarde de la vie, ni les services d'urgence.",
              ],
            },
            {
              title: "2. Admissibilité et comptes",
              body: [
                "Les Services sont destinés à un usage professionnel par les clients, partenaires et personnels autorisés de Fire Rover. La création d'un compte nécessite un code d'enregistrement valide délivré par Fire Rover ou une partie autorisée. Vous devez fournir des informations exactes, être autorisé à agir au nom de tout site ou organisation auquel vous êtes associé, garder votre mot de passe confidentiel et rester responsable de toute activité effectuée sous votre compte. Signalez-nous rapidement toute utilisation non autorisée à l'adresse app-dev@firerover.com.",
              ],
            },
            {
              title: "3. Utilisation acceptable",
              body: [
                "Vous acceptez de ne pas : utiliser les Services à des fins illégales ; accéder à des zones non publiques ou les altérer ; sonder ou tester les mesures de sécurité ; interférer avec les Services ou les perturber ; procéder à l'ingénierie inverse des Services sauf dans les limites autorisées par la loi ; accéder aux données de sites ou d'utilisateurs auxquels vous n'êtes pas autorisé à accéder ; ou dénaturer votre identité ou votre affiliation.",
              ],
            },
            {
              title: "4. Rôles des utilisateurs et gestion des sites",
              body: [
                "Certains utilisateurs peuvent être désignés comme gestionnaires de site avec des autorisations élevées. Si vous exercez ces autorisations, vous déclarez être autorisé à le faire et que cela est conforme aux politiques de votre organisation et à la loi applicable.",
              ],
            },
            {
              title: "5. Notifications et communications",
              body: [
                "En configurant vos préférences de notification, vous consentez à recevoir des communications opérationnelles via les canaux que vous activez (e-mail, SMS/texto et/ou notifications push). Des frais de message et de données peuvent s'appliquer. Vous pouvez modifier ou désactiver les canaux de notification à tout moment dans les Services.",
              ],
            },
            {
              title: "6. Propriété intellectuelle",
              body: [
                "Les Services, y compris tous les logiciels, contenus, conceptions, logos et marques de commerce (notamment « Fire Rover » et « Spark Mobile »), sont la propriété de Fire Rover, LLC. ou de ses concédants de licence. Nous vous accordons une licence limitée, non exclusive, non transférable et révocable pour utiliser les Services uniquement aux fins prévues.",
              ],
            },
            {
              title: "7. Vos données",
              body: [
                "Vous conservez la propriété des informations personnelles et de compte que vous fournissez. En utilisant les Services, vous accordez à Fire Rover le droit de traiter ces informations comme décrit dans la politique de confidentialité afin de fournir et d'améliorer les Services.",
              ],
            },
            {
              title: "8. Services tiers",
              body: [
                "Les Services s'appuient sur des fournisseurs tiers, notamment pour l'hébergement dans le cloud et la distribution des notifications push. Nous ne sommes pas responsables des actes, omissions ou contenus des tiers.",
              ],
            },
            {
              title: "9. Avertissements",
              body: [
                "LES SERVICES SONT FOURNIS « EN L'ÉTAT » ET « SELON LEUR DISPONIBILITÉ », SANS GARANTIE D'AUCUNE SORTE. La distribution des notifications n'est pas garantie. La distribution des alertes dépend de facteurs indépendants de notre volonté, notamment les réseaux des opérateurs, la connectivité Internet, les paramètres de l'appareil, les limites du système d'exploitation et l'infrastructure de tiers. Ne comptez pas sur les Services comme unique moyen de recevoir un avis d'urgence.",
              ],
            },
            {
              title: "10. Limitation de responsabilité",
              body: [
                "DANS TOUTE LA MESURE PERMISE PAR LA LOI, FIRE ROVER, LLC. AINSI QUE SES DIRIGEANTS, ADMINISTRATEURS, EMPLOYÉS ET AGENTS NE SAURAIENT ÊTRE TENUS RESPONSABLES DE TOUT DOMMAGE INDIRECT, ACCESSOIRE, SPÉCIAL, CONSÉCUTIF OU PUNITIF, NI D'AUCUNE PERTE DE PROFITS, DE REVENUS, DE DONNÉES OU DE CLIENTÈLE. NOTRE RESPONSABILITÉ GLOBALE TOTALE N'EXCÉDERA PAS CENT DOLLARS AMÉRICAINS (100 $ US).",
              ],
            },
            {
              title: "11. Indemnisation",
              body: [
                "Vous acceptez d'indemniser et de dégager de toute responsabilité Fire Rover, LLC. et ses sociétés affiliées de toute réclamation, dommage, responsabilité et dépense découlant de votre violation des présentes Conditions, de votre utilisation abusive des Services ou de votre violation de toute loi ou de tout droit de tiers.",
              ],
            },
            {
              title: "12. Suspension et résiliation",
              body: [
                "Nous pouvons suspendre ou résilier votre accès à tout moment, avec ou sans préavis, si nous estimons que vous avez enfreint les présentes Conditions. Vous pouvez cesser d'utiliser les Services à tout moment.",
              ],
            },
            {
              title: "13. Droit applicable et litiges",
              body: [
                "Les présentes Conditions sont régies par les lois de l'État du Michigan, États-Unis. Tout litige relèvera de la compétence exclusive des tribunaux d'État et fédéraux situés dans le Michigan.",
              ],
            },
            {
              title: "14. Modifications des présentes Conditions",
              body: [
                "Nous pouvons mettre à jour les présentes Conditions de temps à autre. La poursuite de l'utilisation après l'entrée en vigueur des modifications constitue une acceptation des Conditions révisées.",
              ],
            },
            {
              title: "15. Contact",
              body: ["legalnotice@firerover.com"],
            },
          ],
        },
        {
          title: "Partie II — Politique de confidentialité",
          intro: [],
          sections: [
            {
              title: "1. Informations que nous collectons",
              body: [
                "a. Informations que vous fournissez : informations de compte et de profil (prénom et nom, adresse e-mail, numéro de téléphone avec indicatif de pays, mot de passe conservé uniquement sous forme hachée, fuseau horaire et langue préférée) ; code d'enregistrement ; préférences de notification (types d'alertes, méthodes de distribution, horaires et modes de notification) ; actions de gestion des sites et des utilisateurs.",
                "b. Informations collectées automatiquement : jetons d'authentification (jetons d'accès et de rafraîchissement JWT stockés dans le stockage sécurisé de l'appareil sur mobile et dans les cookies du navigateur sur le web) ; jetons de notification push via Expo/APNs/FCM ; informations sur l'appareil et de diagnostic pour les rapports de plantage (plateforme, version du système d'exploitation, messages d'erreur, traces de pile, type d'erreur, indicateur fatal, horodatage) ; stockage web (stockage local pour l'e-mail « Se souvenir de moi » et la préférence de thème ; cookies pour le nom, le nom d'utilisateur, les indicateurs de rôle et les jetons d'authentification).",
                "c. Informations sur les sites et les événements : noms et adresses des sites, informations de la station centrale, détails des équipements et historique des notifications d'événements (type d'événement, nom du site et du produit, horodatages, indicateurs d'alerte de test et images associées lorsqu'elles sont disponibles).",
              ],
            },
            {
              title: "2. Comment nous utilisons les informations",
              body: [
                "Pour vous authentifier et maintenir votre session ; fournir les fonctions essentielles des Services, y compris la distribution des alertes ; afficher les sites, les systèmes, l'historique des événements et les informations sur l'état de santé du système ; permettre la gestion des sites et des utilisateurs ; envoyer des communications relatives au compte (codes de réinitialisation de mot de passe et invitations) ; diagnostiquer, déboguer et améliorer les Services ; et assurer la sécurité et respecter les obligations légales.",
              ],
            },
            {
              title: "3. Bases juridiques du traitement",
              body: [
                "Lorsque la loi applicable l'exige (comme le RGPD de l'UE/du Royaume-Uni), nous traitons les informations personnelles sur la base : de l'exécution d'un contrat, de votre consentement (par exemple, l'activation des notifications SMS ou push), de nos intérêts légitimes (sécuriser et améliorer les Services) et du respect des obligations légales.",
              ],
            },
            {
              title: "4. Comment nous partageons les informations",
              body: [
                "Nous ne vendons PAS vos informations personnelles. Nous les partageons uniquement avec : les prestataires de services qui hébergent et exploitent les Services (Microsoft Azure pour l'hébergement dans le cloud ; le service de notifications push d'Apple et Google Firebase Cloud Messaging via Expo pour la distribution des notifications push ; les fournisseurs de télécommunications/e-mail pour les SMS et les e-mails) ; au sein de votre organisation lorsque cela est autorisé ; pour des raisons légales et de sécurité lorsque la loi l'exige ; et dans le cadre d'un transfert d'entreprise.",
              ],
            },
            {
              title: "5. Stockage et sécurité des données",
              body: [
                "Nous utilisons un transport chiffré (HTTPS) pour toutes les communications avec le backend, une authentification par jeton (JWT) avec rafraîchissement automatique et des durées de session limitées, un stockage sécurisé des identifiants sur l'appareil dans l'application mobile, et des mots de passe conservés uniquement sous forme hachée. Les données sont traitées et stockées sur l'infrastructure Microsoft Azure et peuvent être traitées aux États-Unis et dans d'autres pays où opèrent nos prestataires de services.",
              ],
            },
            {
              title: "6. Conservation des données",
              body: [
                "Nous conservons les informations personnelles aussi longtemps que votre compte est actif et aussi longtemps que nécessaire pour fournir les Services, respecter les obligations légales, résoudre les litiges et faire appliquer nos accords. Pour demander une suppression, contactez app-dev@firerover.com.",
              ],
            },
            {
              title: "7. Confidentialité des enfants",
              body: [
                "Les Services sont destinés à un usage professionnel par des adultes et ne s'adressent pas aux enfants de moins de 13 ans. Nous ne collectons pas sciemment d'informations personnelles auprès d'enfants.",
              ],
            },
            {
              title: "8. Vos choix et vos droits",
              body: [
                "Vous pouvez consulter et mettre à jour votre profil, vos coordonnées et vos préférences de notification dans les Services. Selon votre lieu de résidence, vous pouvez disposer de droits en vertu de lois telles que le RGPD ou le CCPA, y compris le droit d'accéder à vos informations personnelles, de les corriger, de les supprimer ou de les transférer, et de vous opposer à certains traitements ou de les limiter. Pour exercer ces droits, contactez app-dev@firerover.com.",
              ],
            },
            {
              title: "9. Services et liens tiers",
              body: [
                "Les Services dépendent de plateformes tierces (Microsoft Azure, Apple, Google et Expo) dont les pratiques en matière de confidentialité sont régies par leurs propres politiques.",
              ],
            },
            {
              title: "10. Modifications de la présente politique de confidentialité",
              body: [
                "Nous pouvons mettre à jour la présente politique de confidentialité de temps à autre. La poursuite de l'utilisation après une mise à jour constitue une acceptation de la politique de confidentialité révisée.",
              ],
            },
            {
              title: "11. Nous contacter",
              body: [
                "Fire Rover, LLC., Farmington Hills, Michigan, États-Unis | app-dev@firerover.com | https://firerover.com",
              ],
            },
          ],
        },
      ],
    },
  },

  "es-ES": {
    privacypolicy: "Política de privacidad",
    "privacy-policy": "Política de privacidad",
    lastupdated: "Última actualización",
    privacyPolicyDoc: {
      title: "Términos de servicio y política de privacidad",
      lastUpdatedDate: "21 de julio de 2026",
      parts: [
        {
          title: "Parte I — Términos de servicio",
          intro: [
            "Los Servicios son proporcionados por Fire Rover, LLC. («Fire Rover», «nosotros» o «nuestro»), ubicada en Farmington Hills, Michigan, Estados Unidos.",
            "Al crear una cuenta, acceder a los Servicios o utilizarlos, usted acepta quedar vinculado por estos Términos de servicio y reconoce que ha leído y comprendido esta política de privacidad. Si no está de acuerdo, no utilice los Servicios.",
          ],
          sections: [
            {
              title: "1. Los Servicios",
              body: [
                "Los Servicios proporcionan herramientas para supervisar y gestionar los sistemas de extinción de incendios de Fire Rover, incluyendo: recibir alertas y notificaciones en tiempo real sobre eventos de extinción de incendios; consultar el historial de notificaciones de eventos; consultar informes de incidentes, informes de enfoque de operaciones y video del sistema; consultar el estado de salud de los equipos asociados; gestionar sitios, sistemas/unidades y usuarios asociados; invitar usuarios y asignar o eliminar funciones de administrador de sitio; y configurar la información personal y las preferencias de notificación (correo electrónico, SMS/texto y notificaciones push), los horarios, el idioma y la zona horaria. Los Servicios son una herramienta complementaria de notificación y gestión. NO sustituyen a un sistema de extinción de incendios correctamente instalado y mantenido, a una central de monitoreo, a los sistemas locales de seguridad contra incendios y protección de la vida, ni a los servicios de emergencia.",
              ],
            },
            {
              title: "2. Elegibilidad y cuentas",
              body: [
                "Los Servicios están destinados al uso empresarial por parte de clientes, socios y personal autorizado de Fire Rover. La creación de una cuenta requiere un código de registro válido emitido por Fire Rover o por una parte autorizada. Usted debe proporcionar información precisa, estar autorizado para actuar en nombre de cualquier sitio u organización con la que esté asociado, mantener su contraseña confidencial y seguir siendo responsable de toda la actividad realizada en su cuenta. Notifíquenos de inmediato cualquier uso no autorizado a app-dev@firerover.com.",
              ],
            },
            {
              title: "3. Uso aceptable",
              body: [
                "Usted acepta no: utilizar los Servicios para fines ilícitos; acceder o manipular áreas no públicas; sondear o probar las medidas de seguridad; interferir con los Servicios o interrumpirlos; realizar ingeniería inversa de los Servicios salvo en la medida permitida por la ley; acceder a datos de sitios o usuarios a los que no esté autorizado a acceder; o tergiversar su identidad o afiliación.",
              ],
            },
            {
              title: "4. Funciones de usuario y gestión de sitios",
              body: [
                "Determinados usuarios pueden ser designados como administradores de sitio con permisos elevados. Si ejerce estos permisos, usted declara que está autorizado a hacerlo y que ello cumple con las políticas de su organización y con la legislación aplicable.",
              ],
            },
            {
              title: "5. Notificaciones y comunicaciones",
              body: [
                "Al configurar las preferencias de notificación, usted consiente en recibir comunicaciones operativas a través de los canales que habilite (correo electrónico, SMS/texto o notificaciones push). Pueden aplicarse tarifas de mensajes y datos. Puede cambiar o desactivar los canales de notificación en cualquier momento dentro de los Servicios.",
              ],
            },
            {
              title: "6. Propiedad intelectual",
              body: [
                "Los Servicios, incluidos todos los programas, contenidos, diseños, logotipos y marcas comerciales (incluidos «Fire Rover» y «Spark Mobile»), son propiedad de Fire Rover, LLC. o de sus licenciantes. Le otorgamos una licencia limitada, no exclusiva, intransferible y revocable para utilizar los Servicios únicamente para su propósito previsto.",
              ],
            },
            {
              title: "7. Sus datos",
              body: [
                "Usted conserva la propiedad de la información personal y de la cuenta que proporciona. Al utilizar los Servicios, usted otorga a Fire Rover el derecho a tratar dicha información según se describe en la política de privacidad para prestar y mejorar los Servicios.",
              ],
            },
            {
              title: "8. Servicios de terceros",
              body: [
                "Los Servicios dependen de proveedores externos, incluidos el alojamiento en la nube y la entrega de notificaciones push. No somos responsables de los actos, omisiones o contenidos de terceros.",
              ],
            },
            {
              title: "9. Renuncias de responsabilidad",
              body: [
                "LOS SERVICIOS SE PROPORCIONAN «TAL CUAL» Y «SEGÚN DISPONIBILIDAD», SIN GARANTÍAS DE NINGÚN TIPO. No se garantiza la entrega de las notificaciones. La entrega de las alertas depende de factores fuera de nuestro control, incluidos las redes de los operadores, la conectividad a Internet, la configuración del dispositivo, los límites del sistema operativo y la infraestructura de terceros. No dependa de los Servicios como su único medio para recibir avisos de emergencia.",
              ],
            },
            {
              title: "10. Limitación de responsabilidad",
              body: [
                "EN LA MÁXIMA MEDIDA PERMITIDA POR LA LEY, FIRE ROVER, LLC. Y SUS DIRECTIVOS, DIRECTORES, EMPLEADOS Y AGENTES NO SERÁN RESPONSABLES DE NINGÚN DAÑO INDIRECTO, INCIDENTAL, ESPECIAL, EMERGENTE O PUNITIVO, NI DE NINGUNA PÉRDIDA DE BENEFICIOS, INGRESOS, DATOS O FONDO DE COMERCIO. NUESTRA RESPONSABILIDAD TOTAL AGREGADA NO SUPERARÁ LOS CIEN DÓLARES ESTADOUNIDENSES (US$100).",
              ],
            },
            {
              title: "11. Indemnización",
              body: [
                "Usted acepta indemnizar y eximir de responsabilidad a Fire Rover, LLC. y a sus filiales de cualquier reclamación, daño, responsabilidad y gasto que se derive de su incumplimiento de estos Términos, de su uso indebido de los Servicios o de su violación de cualquier ley o derecho de terceros.",
              ],
            },
            {
              title: "12. Suspensión y terminación",
              body: [
                "Podemos suspender o cancelar su acceso en cualquier momento, con o sin previo aviso, si consideramos que ha incumplido estos Términos. Usted puede dejar de utilizar los Servicios en cualquier momento.",
              ],
            },
            {
              title: "13. Ley aplicable y controversias",
              body: [
                "Estos Términos se rigen por las leyes del estado de Michigan, Estados Unidos. Toda controversia estará sujeta a la jurisdicción exclusiva de los tribunales estatales y federales ubicados en Michigan.",
              ],
            },
            {
              title: "14. Cambios en estos Términos",
              body: [
                "Podemos actualizar estos Términos ocasionalmente. El uso continuado después de que los cambios entren en vigor constituye la aceptación de los Términos revisados.",
              ],
            },
            {
              title: "15. Contacto",
              body: ["legalnotice@firerover.com"],
            },
          ],
        },
        {
          title: "Parte II — Política de privacidad",
          intro: [],
          sections: [
            {
              title: "1. Información que recopilamos",
              body: [
                "a. Información que usted proporciona: información de la cuenta y del perfil (nombre y apellidos, dirección de correo electrónico, número de teléfono con código de país, contraseña almacenada únicamente en forma cifrada [hash], zona horaria e idioma preferido); código de registro; preferencias de notificación (tipos de alertas, métodos de entrega, horarios y modos de notificación); acciones de gestión de sitios y usuarios.",
                "b. Información recopilada automáticamente: tokens de autenticación (tokens de acceso y de actualización JWT almacenados en el almacenamiento seguro del dispositivo en móvil y en cookies del navegador en la web); tokens de notificación push a través de Expo/APNs/FCM; información del dispositivo y de diagnóstico para informes de fallos (plataforma, versión del sistema operativo, mensajes de error, trazas de pila, tipo de error, indicador de error grave, marca de tiempo); almacenamiento web (almacenamiento local para el correo electrónico de «Recordarme» y la preferencia de tema; cookies para el nombre, el nombre de usuario, los indicadores de función y los tokens de autenticación).",
                "c. Información sobre sitios y eventos: nombres y direcciones de los sitios, información de la central de monitoreo, detalles de los equipos e historial de notificaciones de eventos (tipo de evento, nombre del sitio y del producto, marcas de tiempo, indicadores de alerta de prueba e imágenes relacionadas cuando estén disponibles).",
              ],
            },
            {
              title: "2. Cómo utilizamos la información",
              body: [
                "Para autenticarlo y mantener su sesión; proporcionar las funciones esenciales de los Servicios, incluida la entrega de alertas; mostrar sitios, sistemas, historial de eventos e información sobre el estado de salud del sistema; habilitar la gestión de sitios y usuarios; enviar comunicaciones relativas a la cuenta (códigos de restablecimiento de contraseña e invitaciones); diagnosticar, depurar y mejorar los Servicios; y mantener la seguridad y cumplir con las obligaciones legales.",
              ],
            },
            {
              title: "3. Bases jurídicas del tratamiento",
              body: [
                "Cuando así lo exija la legislación aplicable (como el RGPD de la UE/el Reino Unido), tratamos la información personal sobre la base de: la ejecución de un contrato, su consentimiento (por ejemplo, habilitar las notificaciones por SMS o push), nuestros intereses legítimos (proteger y mejorar los Servicios) y el cumplimiento de las obligaciones legales.",
              ],
            },
            {
              title: "4. Cómo compartimos la información",
              body: [
                "NO vendemos su información personal. Solo la compartimos con: proveedores de servicios que alojan y operan los Servicios (Microsoft Azure para el alojamiento en la nube; el servicio de notificaciones push de Apple y Google Firebase Cloud Messaging a través de Expo para la entrega de notificaciones push; proveedores de telecomunicaciones/correo electrónico para SMS y correo electrónico); dentro de su organización cuando esté autorizado; por motivos legales y de seguridad cuando lo exija la ley; y en relación con una transferencia comercial.",
              ],
            },
            {
              title: "5. Almacenamiento y seguridad de los datos",
              body: [
                "Utilizamos transporte cifrado (HTTPS) para todas las comunicaciones con el backend, autenticación basada en tokens (JWT) con actualización automática y duraciones de sesión limitadas, almacenamiento seguro de credenciales en el dispositivo dentro de la aplicación móvil, y contraseñas almacenadas únicamente en forma cifrada (hash). Los datos se procesan y almacenan en la infraestructura de Microsoft Azure y pueden procesarse en Estados Unidos y en otros países donde operan nuestros proveedores de servicios.",
              ],
            },
            {
              title: "6. Conservación de los datos",
              body: [
                "Conservamos la información personal mientras su cuenta esté activa y durante el tiempo necesario para prestar los Servicios, cumplir con las obligaciones legales, resolver controversias y hacer cumplir nuestros acuerdos. Para solicitar la eliminación, contacte con app-dev@firerover.com.",
              ],
            },
            {
              title: "7. Privacidad de los menores",
              body: [
                "Los Servicios están destinados al uso empresarial por parte de adultos y no están dirigidos a menores de 13 años. No recopilamos a sabiendas información personal de menores.",
              ],
            },
            {
              title: "8. Sus opciones y derechos",
              body: [
                "Puede consultar y actualizar su perfil, su información de contacto y sus preferencias de notificación dentro de los Servicios. Según su lugar de residencia, puede tener derechos en virtud de leyes como el RGPD o la CCPA, incluido el derecho a acceder a su información personal, corregirla, eliminarla o transferirla, y a oponerse a determinados tratamientos o restringirlos. Para ejercer estos derechos, contacte con app-dev@firerover.com.",
              ],
            },
            {
              title: "9. Servicios y enlaces de terceros",
              body: [
                "Los Servicios dependen de plataformas de terceros (Microsoft Azure, Apple, Google y Expo) cuyas prácticas de privacidad se rigen por sus propias políticas.",
              ],
            },
            {
              title: "10. Cambios en esta política de privacidad",
              body: [
                "Podemos actualizar esta política de privacidad ocasionalmente. El uso continuado después de una actualización constituye la aceptación de la política de privacidad revisada.",
              ],
            },
            {
              title: "11. Contáctenos",
              body: [
                "Fire Rover, LLC., Farmington Hills, Michigan, Estados Unidos | app-dev@firerover.com | https://firerover.com",
              ],
            },
          ],
        },
      ],
    },
  },
};

export { privacyPolicyContent };
